if (!customElements.get('card-selection-modal')) {
  const IMAGE_SIZE_REGEX = /\.(jpg|jpeg|png|gif|webp|avif)(\?.*)?$/i;
  const DECLINE_DELAY_MS = 500;
  const IMAGE_LOAD_TIMEOUT_MS = 300;

  const sizedLineItemImageUrl = (lineItem) => {
    if (!lineItem) return '';
    const raw = lineItem.image || lineItem.url || (lineItem.featured_image && lineItem.featured_image.url);
    if (!raw) return '';
    return raw.replace(IMAGE_SIZE_REGEX, '_150x150.$1$2');
  };

  class CardSelectionModal extends ModalDialog {
    shouldShowModalCloseButton() {
      return false;
    }

    shouldCloseOnBackdropClick() {
      return false;
    }

    shouldUseTransition() {
      return true;
    }

    connectedCallback() {
      super.connectedCallback();

      this.lineItemBlock = this.querySelector('[data-card-modal-line]');
      this.lineItemImage = this.querySelector('[data-card-modal-line-image]');
      this.lineItemTitle = this.querySelector('[data-card-modal-line-title]');
      this.lineItemPrice = this.querySelector('[data-card-modal-line-price]');
      this.currencyCode = this.dataset.currency || 'USD';
      this.openDelay = Number(this.dataset.openDelay || 2500);
      this.occasionSelect = this.querySelector('#card-modal-special-occasion');
      this.occasionSliders = this.querySelectorAll('[data-occasion]');
      this.cardPickerElements = this.querySelectorAll('[data-card-modal-card-picker-title], [data-card-modal-card-picker-occasion], [data-card-modal-card-picker-sliders]');
      this.continueButton = this.querySelector('[data-card-modal-continue]');
      this.continueButtonText = this.continueButton?.querySelector('span');
      this.continueButtonDefaultText = this.continueButtonText?.textContent || '';
      this.continueButtonSpinner = this.continueButton?.querySelector('.loading__spinner');
      this.declineButton = this.querySelector('[data-card-modal-decline]');
      this.declineButtonSpinner = this.declineButton?.querySelector('.loading__spinner');
      this.messageField = this.querySelector('#card-modal-message');
      this.messageError = this.querySelector('[data-card-modal-message-error]');

      this.preloadProductImages();

      this.messageField?.addEventListener('input', this.clearMessageError.bind(this));

      if (this.occasionSelect) {
        if (typeof window.Choices === 'function') {
          this.occasionChoices = new Choices(this.occasionSelect, {
            searchEnabled: false,
            itemSelectText: false,
            position: 'bottom',
          });
        }
        this.occasionSelect.addEventListener('change', this.onModalOccasionChange.bind(this));
        this.onModalOccasionChange();
      }

      this.continueButton?.addEventListener('click', this.onContinueClick.bind(this));
      this.declineButton?.addEventListener('click', this.onDecline.bind(this));

      this.cart =
        document.querySelector('cart-notification') || document.querySelector('cart-drawer') || null;

      // this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      //   if (this.dataset.selectorType === 'inline') return;
      //   if (event.source !== 'product-form' || !event.cardOptional) return;
      //   this.productAddResponse = event.cartData;
      //   const lineItem = event.cartData?.items?.[0];
      //   setTimeout(() => {
      //     this.open({
      //       parentLineKey: event.parentLineKey,
      //       showNotification: true,
      //       lineItem,
      //     });
      //   }, 2500);
      // });

      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (this.dataset.selectorType === 'inline') return;
        if (event.source !== 'product-form') return;
        // if (!event.cardOptional && !event.cardProduct) return;
        const lineItem = event.cartData?.items?.[0];
        const lineItemProductType = (lineItem?.product_type || '').toLowerCase();
        const lineItemIsCard = lineItemProductType === 'cards' || lineItemProductType === 'card';
        const isMessageOnly = event.cardProduct || lineItemIsCard;

        if (!event.cardOptional && !isMessageOnly) return;
        
        const popupDisabled =
          document.querySelector('#card-popup-config')?.dataset.popupDisabled === 'true';

        this.productAddResponse = event.cartData;
        // const isMessageOnly = event.cardProduct;

        if (popupDisabled && !isMessageOnly) {
          if (this.cart?.renderContents) {
            this.cart.renderContents(event.cartData);
          }
          return;
        }

        // const lineItem = event.cartData?.items?.[0];

        setTimeout(() => {
          this.open({
            parentLineKey: event.parentLineKey,
            showNotification: true,
            lineItem,
            mode: isMessageOnly ? 'message-only' : 'select-card',
            cardType: event.cardType,
          });
        }, Number.isNaN(this.openDelay) ? 2500 : this.openDelay);
      });

      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-edit-card-message]');
        if (!trigger) return;
        const itemData = JSON.parse(trigger.dataset.editCardMessage);
        this.productAddResponse = null;
        this.open({ parentLineKey: itemData.key, showNotification: false, lineItem: null, mode: 'message-only' });
      });
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
      this.occasionChoices?.destroy?.();
    }

    preloadProductImages() {
      const productImages = document.querySelectorAll('.card__media img, .product__media img, media-gallery img');
      productImages.forEach((img) => {
        const src = img.currentSrc || img.getAttribute('src');
        if (!src) return;
        const sized = src.replace(IMAGE_SIZE_REGEX, '_150x150.$1$2');
        const pre = new Image();
        pre.src = sized;
      });
    }

    onDecline() {
      if (this.isDeclining) return;
      this.isDeclining = true;
      
      this.setDeclineButtonLoading(true);
      
      setTimeout(() => {
        this.setDeclineButtonLoading(false);
        this.isDeclining = false;
        this.resetMessageField();
        this.hide();
        if (this.cart?.renderContents && this.productAddResponse) {
          this.cart.renderContents(this.productAddResponse);
        }
      }, DECLINE_DELAY_MS);
    }

    resetMessageField() {
      if (this.messageField) this.messageField.value = '';
      this.clearMessageError();
    }

    onModalOccasionChange() {
      const value = this.occasionSelect.value;
      this.occasionSliders.forEach((slider) => {
        slider.classList.toggle('hidden', slider.dataset.occasion !== value);
      });
    }

    formatMoney(cents) {
      if (cents == null || Number.isNaN(Number(cents))) return '';
      const amount = Number(cents) / 100;
      try {
        return new Intl.NumberFormat(
          document.documentElement.lang || undefined,
          { style: 'currency', currency: this.currencyCode }
        ).format(amount);
      } catch (e) {
        return amount.toFixed(2);
      }
    }

    populateLineItem(lineItem) {
      if (!this.lineItemBlock) return;

      if (lineItem) {
        if (this.lineItemImage) {
          const sizedSrc = sizedLineItemImageUrl(lineItem);
          if (sizedSrc) {
            this.lineItemImage.src = sizedSrc;
            this.lineItemImage.alt = lineItem.image_alt || lineItem.title || lineItem.product_title || '';
            this.lineItemImage.hidden = false;
          } else {
            this.lineItemImage.removeAttribute('src');
            this.lineItemImage.hidden = true;
          }
        }
        if (this.lineItemTitle) {
          this.lineItemTitle.textContent = lineItem.product_title || lineItem.title || '';
        }
        if (this.lineItemPrice) {
          this.lineItemPrice.textContent = this.formatMoney(lineItem.final_line_price);
        }
      } else {
        if (this.lineItemImage) {
          this.lineItemImage.removeAttribute('src');
          this.lineItemImage.hidden = true;
        }
        if (this.lineItemTitle) this.lineItemTitle.textContent = '';
        if (this.lineItemPrice) this.lineItemPrice.textContent = '';
      }
    }

    open({ parentLineKey, showNotification = false, lineItem = undefined, mode = 'select-card', cardType = 'special' } = {}) {
      this.parentLineKey = parentLineKey;
      this.mode = mode;
      this.cardType = cardType || 'special';
      this.activeLineItemProperties = lineItem?.properties || {};
      this.clearMessageError();
      this.setMode(mode);

      if (!this.lineItemBlock) {
        super.show();
        return;
      }

      this.lineItemBlock.hidden = true;
      this.lineItemBlock.classList.remove('card-selection-modal__line-item--reveal');

      if (showNotification) {
        this.showLineItemWithImage(lineItem);
      } else {
        this.populateLineItem(null);
      }

      super.show();
    }

    setMode(mode) {
      const messageOnly = mode === 'message-only';
      this.cardPickerElements?.forEach((element) => {
        element.hidden = messageOnly;
      });
      if (this.continueButtonText) {
        this.continueButtonText.textContent = messageOnly ? 'Save message' : this.continueButtonDefaultText;
      }
    }

    showLineItemWithImage(lineItem) {
      const sizedSrc = sizedLineItemImageUrl(lineItem);
      
      if (!sizedSrc || !this.lineItemImage) {
        this.populateLineItem(lineItem);
        this.revealLineItem();
        return;
      }

      let revealed = false;
      const reveal = () => {
        if (revealed) return;
        revealed = true;
        this.revealLineItem();
      };

      this.lineItemImage.onload = reveal;
      this.populateLineItem(lineItem);

      if (this.lineItemImage.complete) {
        reveal();
      } else {
        setTimeout(reveal, IMAGE_LOAD_TIMEOUT_MS);
      }
    }

    revealLineItem() {
      this.lineItemBlock.hidden = false;
      void this.lineItemBlock.offsetWidth;
      this.lineItemBlock.classList.add('card-selection-modal__line-item--reveal');
    }

    clearMessageError() {
      if (this.messageError) this.messageError.hidden = true;
      this.messageField?.removeAttribute('aria-invalid');
      this.messageField?.removeAttribute('aria-describedby');
    }

    showMessageRequiredError() {
      if (this.messageError) this.messageError.hidden = false;
      this.messageField?.setAttribute('aria-invalid', 'true');
      this.messageField?.setAttribute('aria-describedby', 'card-modal-message-error');
    }

    onContinueClick() {
      if (this.mode === 'message-only') {
        const message = (this.messageField && this.messageField.value && this.messageField.value.trim()) || '';
        if (!message) {
          this.showMessageRequiredError();
          return;
        }
        this.clearMessageError();
        this.updateCardMessage({
          message,
          cardType: this.cardType,
        });
        return;
      }

      if (!this.occasionSelect) return;
      const occasionId = this.occasionSelect.value;
      const occSlider = this.querySelector(`.card-selection-modal__card-slider[data-occasion="${occasionId}"]`);
      const input = occSlider && occSlider.querySelector('input[type="radio"]:checked');
      if (!input) {
        return;
      }
      const message = (this.messageField && this.messageField.value && this.messageField.value.trim()) || '';
      if (!message) {
        this.showMessageRequiredError();
        return;
      }
      this.clearMessageError();
      const cardType = input.dataset.cardType || 'special';
      this.addCardToCart({
        variantId: input.value,
        cardType,
        message,
      });
    }

    setButtonLoading(button, spinner, loading) {
      if (!button) return;
      button.classList.toggle('loading', loading);
      button.toggleAttribute('aria-disabled', loading);
      spinner?.classList.toggle('hidden', !loading);
    }

    setContinueButtonLoading(loading) {
      this.classList.toggle('card-selection-modal--loading', loading);
      this.setButtonLoading(this.continueButton, this.continueButtonSpinner, loading);
    }

    setDeclineButtonLoading(loading) {
      this.setButtonLoading(this.declineButton, this.declineButtonSpinner, loading);
    }

    addCardToCart({ variantId, cardType, message }) {
      if (this.isAddingCard) return Promise.resolve();
      this.isAddingCard = true;

      this.setContinueButtonLoading(true);

      const config = fetchConfig('javascript');

      config.body = JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1,
            parent_line_key: this.parentLineKey,
            properties: {
              _card: true,
              _type: cardType,
              Message: message,
            },
          },
        ],
        sections: this.cart ? this.cart.getSectionsToRender().map((s) => s.id) : [],
        sections_url: window.location.pathname,
      });

      return fetch(`${routes.cart_add_url}.js`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            console.error('Card add failed:', response.description);
            return;
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'card-selection-modal',
            cartData: response,
          });

          this.resetMessageField();
          this.hide();
          if (this.cart?.renderContents) {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.setContinueButtonLoading(false);
          this.isAddingCard = false;
        });
    }

    updateCardMessage({ message, cardType }) {
      if (this.isAddingCard) return Promise.resolve();
      this.isAddingCard = true;

      this.setContinueButtonLoading(true);

      const config = fetchConfig('javascript');

      config.body = JSON.stringify({
        id: this.parentLineKey,
        properties: {
          ...this.activeLineItemProperties,
          _card: true,
          _type: cardType || 'special',
          Message: message,
        },
        sections: this.cart ? this.cart.getSectionsToRender().map((s) => s.id) : [],
        sections_url: window.location.pathname,
      });

      return fetch(`${routes.cart_change_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            console.error('Card message update failed:', response.description);
            return;
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'card-selection-modal',
            cartData: response,
          });

          this.resetMessageField();
          this.hide();
          if (this.cart?.renderContents) {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.setContinueButtonLoading(false);
          this.isAddingCard = false;
        });
    }
  }

  customElements.define('card-selection-modal', CardSelectionModal);
}
